import Icon from '../components/Icon.vue'

Icon.register({
  wallet: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M461.2 128H80C71.2 128 64 120.8 64 112S71.2 96 80 96H464C472.8 96 480 88.8 480 80 480 53.5 458.5 32 432 32H64C28.6 32 0 60.6 0 96V416C0 451.4 28.6 480 64 480H461.2C489.2 480 512 458.5 512 432V176C512 149.5 489.2 128 461.2 128zM416 336C398.3 336 384 321.7 384 304S398.3 272 416 272 448 286.3 448 304 433.7 336 416 336z'
      }
    ]
  }
})
